import React from 'react';
import { NewButton } from 'components/Button/NewButton/NewButton';
import Text from 'components/Text/Text';

interface IProps {
	isSaveDisabled?: boolean;
	isCancelDisabled?: boolean;
	onCancel: () => void;
}

export const FormActions: React.FC<IProps> = ({ isSaveDisabled = false, isCancelDisabled = false, onCancel }) => (
	<div className="pb-4 flex justify-end gap-4" data-test="FormActions">
		<NewButton variant="outline" color="gray" disabled={isCancelDisabled} testId="CancelBtn" onClick={onCancel}>
			<Text translationNameSpace="form" translationKey="cancelButton" asFragment={true} />
		</NewButton>
		<NewButton type="submit" disabled={isSaveDisabled} testId="SaveBtn">
			<Text translationNameSpace="form" translationKey="saveButton" asFragment={true} />
		</NewButton>
	</div>
);
